// interactive events into React events
const mapMIEventsToReact = new Map([
  ['over', ['onMouseOver', 'onTouchStart']],
  ['leave', ['onMouseLeave', 'onTouchCancel', 'onTouchEnd']],
  ['click', ['onClick']],
  ['input', ['onInput']],
]);

// web events into interactive events
const mapWebEventsToMIEvents = new Map([
  ['touchstart', 'over'],
  ['touchend', 'leave'],
  ['touchcancel', 'leave'],
  ['mouseover', 'over'],
  ['mouseleave', 'leave'],
]);

export {
  toWeb,
  toMIEvent,
};

/**
 * Rename and expand MegogoInteractive platform agnostic event name to React compatible events.
 * over <-> onMouseOver, onTouchStart
 * @param {string} eventName
 * @return {string[]}
 */
function toWeb(eventName) {
  return mapMIEventsToReact.get(eventName) || eventName;
}

/**
 * Rename native HTMLEvent.type into MegogoInteractive platform agnostic event name.
 * [onMouseOver | onTouchStart] -> over
 * @param {string} eventName
 * @return {string}
 */
function toMIEvent(eventName) {
  return mapWebEventsToMIEvents.get(eventName) || eventName;
}
